import { EnvironmentConfig } from '@cigna/chcp/shared/environment-util';

export const environment: EnvironmentConfig = {
  production: true,
  oidc: {
    clientId: 'chcp_spa_client',
    redirectUri: '/app/auth_callback.html',
    metadataUri: '/mga/sps/oauth/oauth20/metadata/chcp_spa_def',
    authorizeUri: '/mga/sps/oauth/oauth20/authorize',
    secureUris: ['https://p-chcp.digitaledge.cigna.com', '/prv/secure'],
    publicUris: [],
    noRefreshUris: [],
  },
  api: {
    proxy: {
      headers: {
        accept: '*/*',
        content_type: 'application/json',
      },
    },
    gateways: {
      cdn: 'https://static.cigna.com/',
      secureApi: 'https://p-chcp.digitaledge.cigna.com/chcp',
      publicApi: 'https://p-chcp.digitaledge.cigna.com/public',
      gsgPublicApi: 'https://p-gsg.digitaledge.cigna.com/public',
      gsgSecureApi: 'https://p-gsg.digitaledge.cigna.com',
    },
    searchIndex: 'prod',
    salesDemo: false,
  },
  sessionTimeoutPopup: {
    timeoutDuration: 25,
    logoutDuration: 5,
    keepAliveUrl: '/app/assets/images/isam-keepalive.gif',
  },
  trustId: '5045161',
  features: {
    trust: true,
    claimsRecon: true,
    claimsReconDental: true,
    patientOldView: true,
    patientEnhBehaviorEmbedded: true,
    patientEnhBehaviorStandalone: false,
    patientEnhPower: false,
    patientEnhDentalAmInNet: false,
    messageCenter: true,
    claimsMcNotification: false,
    messageCenterPreference: false,
    reconAppealsEnhanced: true,
    claimSupportInfo: true,
    precertAppeal: true,
    precertManual: false,
    precertDg: true,
    nextRelease: false,
    patientEnhDentalFacets: true,
    emailVerifyPopup: false,
    pdlViewer: true,
    dashboardNewFeatures: true,
    allowMfaSetting: false,
    mfaVerify: true,
    mfaLogin: true,
    precertAppealDental: true,
    reconBanner: true,
    overPaidClaimsInfo: true,
    multiMatchFlaggedClaim: true,
    manageAccessBulkApi: true,
    claim360: false,
    claim360SearchClaim: false,
    claim360SearchOffice: false,
    claim360SearchProvider: false,
    csnBenefits: false,
  },
};
